import type { SaveStatus } from './autosave';

/**
 * The autosave status line — quiet reassurance, not a demand for action.
 *
 * A client filling a form needs to trust their answers are kept; they should never wonder whether
 * to press "save" (there is no save button). "saved" is the resting state after any write; "error"
 * is the only one that asks for attention, and even then the work is buffered and retried, so the
 * copy stays calm.
 *
 * `role="status"` (a polite live region) so a screen reader announces "saved" without stealing focus.
 */
export function SaveIndicator({ status }: { status: SaveStatus }) {
  if (status === 'idle') return <div className="room-savestate" role="status" aria-live="polite" />;

  const text =
    status === 'saving' ? 'שומר…' : status === 'saved' ? 'נשמר' : 'לא נשמר — ננסה שוב אוטומטית';

  return (
    <div className="room-savestate" data-status={status} role="status" aria-live="polite">
      {text}
    </div>
  );
}
